
//console.log('env:' + process.env.NODE_ENV)
//console.log('VUE_APP_MOCK_ENABLED:' + process.env.VUE_APP_MOCK_ENABLED)
console.log('check (process.env.VUE_APP_MOCK_ENABLED === true) :' + (process.env.VUE_APP_MOCK_ENABLED == 'on') )
//if (process.env.VUE_MOCK_ENABLED == 'on') {
// 判断环境不是 prod 或者 preview 是 true 时，加载 mock 服务
if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {

  // 使用同步加载依赖
  const Mock = require('mockjs')
  require('./services/insurancedata')
  require('./services/holderdata')
  require('./services/chartdata1')
  require('./services/chartsmock')
  require('./services/commonmock')
  Mock.setup({
    timeout: 500 // 请求延时时间
  })
  console.log('mock mounted')
}